import React from 'react';
import './InvoiceRecur.css';

const RecurringInvoiceSection = ({
  isRecurring,
  setIsRecurring,
  recurringInterval,
  setRecurringInterval,
  recurringEnd,
  setRecurringEnd,
  isMobile
}) => {
  return (
    <div className="InvoiceForm__recur-container">
      <h3 className="InvoiceForm__section-title">Recurring Invoice</h3>
      <div className="InvoiceForm__recur-toggle-row">
        <label className="InvoiceForm__recur-toggle-label">
          <input
            type="checkbox"
            checked={isRecurring}
            onChange={e => setIsRecurring(e.target.checked)}
            className="InvoiceForm__recur-checkbox"
          />
          Make this a recurring invoice
        </label>
      </div>
      {isRecurring && (
        <div className="InvoiceForm__recur-options-row">
          <div className="InvoiceForm__recur-field">
            <label className="InvoiceForm__label">Recurring Interval</label>
            <select
              className="InvoiceForm__select"
              value={recurringInterval}
              onChange={e => setRecurringInterval(e.target.value)}
            >
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
              <option value="quarterly">Quarterly</option>
              <option value="yearly">Yearly</option>
            </select>
          </div>
          <div className="InvoiceForm__recur-field">
            <label className="InvoiceForm__label">End Date (Optional)</label>
            <input
              type="date"
              className="InvoiceForm__input"
              value={recurringEnd}
              min={new Date().toISOString().split('T')[0]}
              onChange={e => setRecurringEnd(e.target.value)}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default RecurringInvoiceSection;
